import { ApiParameter, get } from "@insite/client-framework/Services/ApiService"
import { BaseModel } from "@insite/client-framework/Types/ApiModels";

export interface InventoryEDDParams extends ApiParameter {
    Item: string;
    Weight: string;
    DestinationZipCode: string;
}

export interface InventoryEDDModal {
    intransitDays: string;
    deliveryDate: string;
    commitment: string;
    returnCode: string;
    returnMsg:string;
    isSuccessStatusCode:string;
    properties:any
}

const getInventoryEDDUrl = "/api/v1/getinventoryedd";

export function getInventoryEDD(parameter: InventoryEDDParams) {
    const response =  get<InventoryEDDModal>(getInventoryEDDUrl, parameter);
    return response;
}